var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-section',{attrs:{"id":"about-our-product"}},[_c('base-section-heading',{attrs:{"icon":"mdi-account-group","title":"We Are All The SA"}}),_c('v-container',[_c('v-row',_vm._l((_vm.cards),function(card){return _c('v-col',{key:card.title,attrs:{"cols":"12","md":"4"}},[_c('base-info-card',_vm._b({},'base-info-card',card,false))],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }